module.exports = __webpack_public_path__ + "img/customers-active.9475fb30.svg";